export const templateOfImageBlock = `
    <div class="row content-block">
        <div class="col-12 column pa-0">
            <img class="custom-image-banner large" src="/assets/editor_images/sample_image_1.jpg"/>
        </div>
    </div>
`
